<template>
  <a-card title="VIP 管理" >
    <div style="margin: 10px auto;">
      <a-space >
      <a-form layout="inline" :model="formSearch">
        <a-form-item>
          <a-input placeholder="用户 ID" v-model:value="formSearch.query" />
        </a-form-item>
        <a-form-item>
          <a-button
            type="primary"
            html-type="submit"
            @click="handleTableChange()"
            shape="circle"
          >
          <template #icon><SearchOutlined /></template>
          </a-button>
        </a-form-item>
        <a-form-item>
           <router-link :to="{ path: '/home/vips/create'}"  >
            开通 VIP
          </router-link>
        </a-form-item>
        <a-form-item>
          <div style="position: relative; display: inline-block;">
            <a-button
              danger
              :disabled="!formSearch.query || !formSearch.query.trim()"
              @click="handleDeleteVip"
            >
              删除账号VIP
            </a-button>
            <a-tooltip title="只有测试账号才支持该功能哦">
              <QuestionCircleOutlined style="position: absolute; top: -6px; right: -10px; color: #faad14; font-size: 16px; cursor: pointer; background: #fff; border-radius: 50%;" />
            </a-tooltip>
          </div>
        </a-form-item>
      </a-form>
      </a-space>
    </div>

    <a-alert :message="noticeMessage" type="info" show-icon style="text-align: left;"  />
      <a-table 
      class="ant-table-striped"
      :row-key="record => record.id"
      :data-source="dataSource" 
      :columns="columns" 
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      >
        <template #nickname="{ record }">
          <span>{{ record.nickname ? record.nickname : '-' }}</span>
        </template>
        <template #phone="{ record }">
          <a-tooltip>
            <template #title>{{ record.phone }}</template>
            {{ record.phone ? "*******" + record.phone.substr(record.phone.length -4, 4) : '-' }}
          </a-tooltip>
        </template>
        <template #is_vip="{ record }">
          <a-tag v-if="record.is_vip" color="red">VIP</a-tag>
        </template>
        <template #action="{ record }">
          <a-space>
            <!-- <a-button v-if="record.is_delete == 0"   warn @click="handleUpdate(record)"  >编辑</a-button> -->
            <a-popconfirm
              title="确定过期吗?"
              ok-text="确定"
              cancel-text="不了"
              @confirm="handleExpire(record)"
            >
              <a-button  danger   >失效</a-button>
            </a-popconfirm>
            
          </a-space>
          </template>
    
      </a-table>
  </a-card>
  <a-modal width="60%"  v-model:visible="openDia" :title="'授予 VIP'" @cancel="resetForm" @ok="handleConfirm" :confirm-loading="confirmLoading">
    <a-form :label-col="{ span:3 }" :model="formAdd"  style="margin: 10px auto;" :rules="rules" ref="formRef" >
       <a-form-item  label="区号" name="country_code">
          <a-input :allowClear="true" placeholder="区号" v-model:value="formAdd.country_code" />
        </a-form-item>
        <a-form-item label="手机号" name="phone">
          <a-textarea :allowClear="true" :rows="4" placeholder="手机号，换行符分割" v-model:value="formAdd.phone" />
          <!-- <a-input :allowClear="true" placeholder="手机号" v-model:value="formAdd.phone" /> -->
          (支持批量，换行分割，总数: {{ inputPhones.length }})
        </a-form-item>
          <a-form-item label="外显ID" name="outer_ids">
          <a-textarea :allowClear="true" :rows="4" placeholder="外显 ID，换行符分割" v-model:value="formAdd.outer_ids" />
          <!-- <a-input :allowClear="true" placeholder="手机号" v-model:value="formAdd.phone" /> -->
          (支持批量，换行分割，总数: {{ inputOuterIDs.length }})
        </a-form-item>
        <a-form-item label="UserID" name="user_id">
          <a-input placeholder="用户 ID" v-model:value="formAdd.user_id" />
          <a-alert message="手机、外显ID、用户 ID 三选一，手机号 > 外显 ID > 用户 ID" type="warning"></a-alert>
        </a-form-item>
       <a-divider />
       <div style="margin: 10px;">
        <a-alert message="以下两个套餐，选哪个就给发哪个。都选都发。" type="info" show-icon  />
       </div>
        <a-form-item :allowClear="true"  label="会员套餐"  name="meal_id">
          <div style="display: flex;flex-direction: row;">
            <div style="display: flex;flex-direction: column;">
              <a-select
                :allowClear="true"
                v-model:value="formAdd.meal_id"
                :options="mealOptions"
                placeholder="套餐"
              />
              <p style="color: red;">*实际购买成功的用户只能填写套餐，不要填写天数</p>
              <a-alert message="填写正确的套餐有助于后续的权益判断，尽量使用套餐而非天数。选择套餐后会优先使用套餐。" type="warning"></a-alert>
              <div style="margin-top:4px;" >
                 <a-form-item :allowClear="true"  label="会员策略"  name="vip_tier_type">
                  <a-select 
                    style="width: 200px;"
                    :allowClear="true"
                    v-model:value="formAdd.vip_tier_type"
                    :options="vipTierTypeOptions"
                    placeholder="策略 ID"
                  />
                </a-form-item>
              </div>
            </div>
            <div style="margin-left: 10px;">
               <a-form-item :allowClear="true"  label="指定天数"  name="days">
                <a-select 
                  style="width: 100px;"
                  :allowClear="true"
                  v-model:value="formAdd.days"
                  :options="productOptions"
                  placeholder="天数"
                />
              </a-form-item>  
            </div>
          </div>
        </a-form-item>
         <a-form-item :allowClear="true"  label="加量包套餐"  name="score_meal_id">
          <a-select
            :allowClear="true"
            v-model:value="formAdd.score_meal_id"
            :options="scorePackMealOptions"
            placeholder="加量包套餐"
          />
        </a-form-item>
        <a-divider />
        <a-form-item label="原始交易 ID" name="origin_transaction_id">
          <a-input :allowClear="true" placeholder="Origin Transaction ID" v-model:value="formAdd.origin_transaction_id" />
          <a-alert message="填写通过苹果订单号查到 Origin Transaction ID，填写此项将支持「自动续费」到当前账号" type="warning"></a-alert>
        </a-form-item>
        <a-form-item label="交易 ID" name="transaction_id">
          <a-input :allowClear="true" placeholder="交易 ID" v-model:value="formAdd.transaction_id" />
          <a-alert message="填写通过苹果订单号查到 Transaction ID" type="warning"></a-alert>
        </a-form-item>
         <a-divider />
        <a-form-item required label="开通说明" name="remark">
          <a-input :allowClear="true" placeholder="开通说明" v-model:value="formAdd.remark" />
        </a-form-item>
      </a-form>
  </a-modal>
  <!-- <UserEditor v-model:visible="userEditorVisible" @cancle="userEditorVisible=false" /> -->

</template>
<script>
import { defineComponent,  onMounted} from 'vue'
// import UserEditor from '@/components/UserEditor.vue'
import { SearchOutlined, QuestionCircleOutlined } from '@ant-design/icons-vue';
import axios from 'axios'
import { message } from 'ant-design-vue';
import request from '@/utils/request'
import { Modal } from 'ant-design-vue';
import { useStore } from 'vuex'

const defaultVIPRecord = {
  phone: '',
  outer_ids: '',
  vip_tier_type: "2",
  country_code: "+86",
  user_id: '',
  days: '',
  meal_id: '',
  score_meal_id: '',
  transaction_id: '',
  origin_transaction_id: '',
  remark: ''
}

export default defineComponent({
  components: {
    // UserEditor,
    SearchOutlined,
    QuestionCircleOutlined
  },
  data(){
    return {
    vipTierTypeOptions: [
        // {
        //   label:"老策略（每天100次）",
        //   value: "1",
        // },
        {
          label:"新策略（每月100次）",
          value: "2",
        },],
    scorePackMealOptions: [
      {
        label: "100次 38元", value: "200",
      },
      {
        label: "500次 168元", value: "210",
      },
      {
        label: "1000次 268元", value: "220",
      },
      {
        label: "20次 9.9元", value: "230",
      }, 
    ],
    mealOptions: [
      {
        label: "周会员 Weekly", value: "5",
      },
      {
        label: "月会员 Monthly", value: "8",
      },
      {
        label: "半年会员 6Month", value: "7",
      },
      {
        label: "年会员 1Year", value: "6",
      }, {
        label: "海外周会员 freetrial_weekly", value: "100",
      },
      {
        label: "海外年会员 freetrial_yearly", value: "110",
      },
    ],
      productOptions: [
        {
          label:"无",
          value: "",
        },
        {
          label:"1天",
          value: "1",
        },
        {
          label:"2天",
          value: "2",
        },
        {
          label:"3天",
          value: "3",
        },
        {
          label:"4天",
          value: "4",
        },
        {
          label:"5天",
          value: "5",
        },
        {
          label:"6天",
          value: "6",
        },
        {
          label:"7天",
          value: "7",
        },
        {
          label:"10天",
          value: "10",
        },
        {
          label:"1个月",
          value: "30",
        },
        {
          label:"3.5个月",
          value: "108",
        },
        {
          label:"6个月",
          value: "180",
        },
        {
          label:"12个月",
          value: "365",
        }, {
          label:"终身",
          value: "18250", // 50 * 365
        }
      ],
      loading: false,
      openDia: false,
      dataSource: [],
      formAdd: {
        ...defaultVIPRecord
      },
      pagination: {
        total: 1,
        current: 0,
        pageSize: 20,
        'show-size-changer': true,
        pageSizeOptions: ['20', '50', '100']
      },
      noticeMessage: '',

       formSearch: {
        query: ''
      },
      confirmLoading: false,
      uploadLoading: false,
    }
  },
  mounted(){
    this.handleTableChange()
  },
  computed:{
    nickname : () => {
      const store = useStore()
      if (store) {
        return store.state.user.nickname
      }
      
    },
    inputOuterIDs: function(){
      if (!this.formAdd.outer_ids) {
        return []
      }
      return this.formAdd.outer_ids.split("\n")
    },
    inputPhones : function(){
      if (!this.formAdd.phone) {
        return []
      }
      return this.formAdd.phone.split("\n")
    },
  },
  methods: {
    async handleConfirm(){
      this.formAdd.phone = this.formAdd.phone.trim()
      this.formAdd.user_id = this.formAdd.user_id.trim()
      this.formAdd.country_code = this.formAdd.country_code.trim()
      if (!this.formAdd.phone && !this.formAdd.user_id && !this.formAdd.outer_ids) {
        Modal.warning({
          title: '提示',
          content: '请输入手机号或用户 ID或外显 ID',
        });
        return
      }
      if (!this.formAdd.days && !this.formAdd.meal_id && !this.formAdd.score_meal_id) {
        Modal.warning({
          title: '提示',
          content: '请选择天数或套餐',
        });
        return
      }
      if (!this.formAdd.remark) {
        Modal.warning({
          title: '提示',
          content: '请输入开通说明',
        });
        return
      }
      this.confirmLoading = true
      if (this.formAdd.meal_id || this.formAdd.days) {
        const rsp = await request.post('/api/vips/grant/vip', {
          ...this.formAdd,
          vip_tier_type: +this.formAdd.vip_tier_type,
          days: +this.formAdd.days,
        })
      }
      if (this.formAdd.score_meal_id){
        const rsp = await request.post('/api/vips/grant/score_pack', {
          ...this.formAdd,
          days: +this.formAdd.days,
        })
      }
      this.confirmLoading = false
      this.openDia = !this.openDia
      this.$refs.formRef.resetFields();

    },
    resetForm() {
      this.$refs.formRef.resetFields();
    },
    async handleDeleteVip() {
      const userId = (this.formSearch.query || '').trim()
      if (!userId) {
        message.warning('请输入用户 ID')
        return
      }
      try {
        const rsp = await request.post('/api/vips/delete', {
          user_id: userId,
        }, '删除账号VIP成功')
        if (!rsp?.code) {
          this.handleTableChange({
            ...this.pagination,
            current: 1,
          })
        }
      } catch (e) {
        message.error('删除账号VIP失败')
      }
    },
    async handleExpire(record){
      const rsp = await request.post(`/api/vips/reset`, {
        "user_id": `${record.user_id}`,
      })
      this.handleTableChange( this.pagination)
    },
    async handleTableChange (pagi = {pageSize: 20, current: 1}) {
      this.loading = true
      const rsp = await request.get('/api/vips/', {
        offset: (pagi.current - 1) * pagi.pageSize ,
        limit: pagi.pageSize,
        user_id: this.formSearch.query
      })
      this.loading = false
      this.dataSource = [].concat(rsp.data.list)
      this.noticeMessage = `共 ${rsp.data.pagination.total} 条`
      this.pagination.total = rsp.data.pagination.total
      this.pagination.current = pagi.current
      this.pagination.pageSize = pagi.pageSize
    },
  },
  setup(props, context) {
   
    return {
      uploadInput: null,
      columns: [
      {
          title: 'UID',
          dataIndex: 'user_id',
          key: 'user_id',
        },
        {
          title: '用户昵称',
          dataIndex: 'nickname',
          key: 'nickname',
          slots: { customRender: 'nickname' },
        },
        {
          title: '订阅 ID',
          dataIndex: 'vip_meal_id',
          key: 'vip_meal_id',
        },
        {
          title: '订阅名称',
          dataIndex: 'vip_meal_name',
          key: 'vip_meal_name',
        },
        // {
        //   title: '付费',
        //   dataIndex: 'pay_amount',
        //   key: 'pay_amount',
        //   // slots: { customRender: 'is_vip' },
        // },
        {
          title: '过期时间',
          dataIndex: 'expired_at',
          key: 'expired_at',
          // slots: { customRender: 'is_vip' },
        },
        {
          title: '是否订阅续期',
          dataIndex: 'is_renewal',
          key: 'is_renewal',
          // slots: { customRender: 'is_vip' },
        },
        {
          title: '备注',
          dataIndex: 'remark',
          key: 'remark',

        },
        {
          title: '创建时间',
          dataIndex: 'created_at',
          key: 'created_at',
        },
        {
          title: '修改时间',
          dataIndex: 'updated_at',
          key: 'updated_at',
        },{
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
        
       
      ],
    };
  },
})
</script>

<style scoped>
.ant-table-striped :deep(.table-striped) td {
  background-color: #fafafa;
}
</style>
